export default [
    {
        name: '__checkbox',
        titleClass: 'center aligned',
        dataClass: 'center aligned'
    },
    {
        name: 'word',
        sortField: 'word',
        type: 'string',
        callback: 'similarKeyWord',
        useInFilter: true,
        defaultSearch: true
    },
    {
        name: 'weight',
        sortField: 'weight',
        type: 'number',
        dataClass: 'ral',
        useInFilter: true,
        isDefault: true
    },
    {
        name: 'frequency',
        sortField: 'ws',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        useInFilter: true,
    },
    {
        name: 'numwords',
        sortField: 'numwords',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        useInFilter: true,
    },
    {
        name: 'isgeo',
        type: 'bool',
        useInFilter: true,
        visible: false,
    },
    {
        name: 'isquest',
        type: 'bool',
        useInFilter: true,
        visible: false,
    },
    {
        name: '__slot:keys_meta',
        dataClass: 'text-center',
        useInFilter: false,
    },

]
